import React, {useEffect, useState} from "react";
import "./App.css";
import {Route, Switch} from "react-router-dom";
import Routes from "../routing/Routes";

// Redux
// Combine react and redux together
import {loadUser} from "../../actions/auth";
import {Home as HomeIcon, ExitToApp as ExitToAppIcon} from "@mui/icons-material"
import {ThemeProvider, CssBaseline} from "@mui/material"
import {makeStyles} from "@mui/styles"
import logoImageUrl from "../../img/logo.png";
import {
    AuthGState,
    theme,
    darkTheme,
    Navbar,
    getAllOrgsIdsForUserByServiceName,
    MainLoader,
    useFavoriteTheme
} from "@leap4/frontend";
import {useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import {connect} from "react-redux";

import {logout} from "../../actions/auth";
import {History} from "history";
import {BACKEND_SERVICE_NAME, requiredAuthRoles} from "../../config/generals";
import {IUser, User} from "@leap4/auth";


interface Props {
    history: History,
    auth: AuthGState
}

const App = ({history, auth}: Props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true)
    const [bIsSidebarOpen, SetSideBarOpenState] = useState(false);
    const [selectedTheme, setSelectedTheme] = useFavoriteTheme()
    const nSidebarWidth = 240;
    const useStyles = makeStyles((theme: any) => ({
        // root: {
        //   display: "display",
        //   maxWidth: "100%",
        //   margin: "auto",
        // },
        root: {
            display: "flex",
        },

        appBarShift: {
            marginLeft: nSidebarWidth,
            width: `calc(100% - ${nSidebarWidth}px)`,
            transition: theme.transitions?.create(["width", "margin"], {
                easing: theme.transitions?.easing.sharp,
                duration: theme.transitions?.duration.enteringScreen,
            }),
        },

        hide: {
            display: "none",
        },

        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: '0 15px',
            // necessary for content to be below app bar
            ...theme?.mixins?.toolbar,
        },

        content: {
            flexGrow: 1,
            padding: '10px',
            width: "100%",
            margin: "auto",
        },
    }));
    const classes = useStyles();

    useEffect(() => {
        (async () => {
                try {
                    await loadUser(dispatch);
                } finally {
                    setIsLoading(false)
                }
            }
        )();
    }, []);

    const getUserOrganizations = () => {
        const userOrgs = getAllOrgsIdsForUserByServiceName(auth.user, (auth.user).organizations as string[], requiredAuthRoles, BACKEND_SERVICE_NAME)
        return userOrgs

    }

    const handleThemeChange = (isLightTheme: boolean) => {
        const themeToSet = isLightTheme ? theme : darkTheme;
        setSelectedTheme(themeToSet)
    }

    const navbarLinks = [
        {text: "Users", link: [
            {text: "All users", link:"/users"},
            {text: "External", link:"/users/external"},
            {text: "Internal", link:"/users/internal"}
            ]
        },
        {text: "Services", link: "/services"},
        {text: "Organizations", link: "/organizations"},
    ];

    if (isLoading) {

        return(
            <div style={{
                margin: "30vh auto"
            }}>
                <MainLoader/>
            </div>
        )
    }

    return (
        <>
            <ThemeProvider theme={selectedTheme}>

                <div className={classes.root}>
                    <CssBaseline/>
                    {auth.user && (
                        <Navbar
                            bIsSidebarOpen={bIsSidebarOpen}
                            handleDrawerClose={() => SetSideBarOpenState(false)}
                            handleDrawerOpen={() => SetSideBarOpenState(true)}
                            auth={{isAuthenticated: true}} ui={{nSidebarWidth, nNavbarHeight: 6}}
                            location={location.pathname} links={navbarLinks}
                            updateCheckedToFather={(checked) => {
                                handleThemeChange(checked)
                            }}
                            title={"Leap4 Users"} logoImageUrl={logoImageUrl}
                            orgsWithPermssions={getUserOrganizations()}

                            logout={{
                                text: "Logout",
                                action: async () => logout(dispatch, history),
                                icon: <ExitToAppIcon/>
                            }}
                        />
                    )}
                    <main className={classes.content}>
                        <div className={classes.toolbar}/>
                        <Switch>
                            <Route component={Routes}/>
                        </Switch>
                    </main>
                </div>
            </ThemeProvider>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth,
    };
};

export default connect(mapStateToProps)(App);
